const DEFAULT_LOCATION = {
  id: '12622',
  name: 'Robina',
  postcode: '4226',
  state: 'QLD',
  latitude: '-28.078134',
  longitude: '153.389243',
  publication: 'Gold Coast',
  region: 'Gold Coast',
  fallback: false,
  distance: 1.3543272841120444,
  url_name: 'robina-qld',
};

export default DEFAULT_LOCATION;
